import { CommonModule } from '@angular/common';
import {Component, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { LanguageSelectComponent } from "../language-select/language-select.component";
import {LocalStorageUtils} from '../../shared/utils/local-storage-utils';
import {AppConstants} from '../../shared/app-constants';

@Component({
  selector: 'app-header',
  imports: [CommonModule, FormsModule, SelectModule, ButtonModule, LanguageSelectComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  warningExpanded = false;
  selectedLanguage!:string;
  isTerminal: boolean = false;

  ngOnInit(): void {
    this.isTerminal = LocalStorageUtils.isOnTerminal();
  }

  dataSource = [
    { code: 'en', name: 'English', flag: 'gb.svg' },
    { code: 'zh', name: '中文', flag: 'cn.svg' },
    { code: 'ms', name: 'Bahasa Melayu', flag: 'my.svg' },
    { code: 'ta', name: 'தமிழ்', flag: 'in.svg' },
    { code: 'fr', name: 'Français', flag: 'fr.svg' },
    { code: 'de', name: 'Deutsch', flag: 'de.svg' },
    { code: 'es', name: 'Español', flag: 'es.svg' },
  ];

  onOptionSelected(event:string){
    this.selectedLanguage = event;
  }

  onWarningToggle() {
    this.warningExpanded = !this.warningExpanded;
  }

  handleDropdownKey(event: any) {
    return AppConstants.handleDropdownKey(event);
  }

}
